import { useRouter } from 'next/router'
import { getCategoryPosts } from '/lib/api';
import React, { useState, useEffect } from "react";
import Link from 'next/link';
import dynamic from 'next/dynamic';
import classes from '../../../styles/blog-single-category.module.css'
import { formatDate, readTime, getWebsiteID } from '/lib/common-functions';
import Skeleton from "react-loading-skeleton";
import { useCookies } from "react-cookie"
import Head from 'next/head'
import { useIsMobile } from '/lib/hooks/useIsMobile';
import { generateBreadcrumbs } from '/lib/services/helpers/generateBreadCrumbs';
import { getBreadCrumbURL } from '/lib/services/helpers/getWebsiteURL';
import { getRedirectionURL } from '/lib/services/helpers/getRedirectionURL';
import { useNotifyModal } from '/lib/hooks/useNotifyModal';
 
const NotifyModal = dynamic(() => import('/components/NotifyModal'))

async function getNewData(category, cursor) {
	const response = await fetch("/api/blog-load-more", {
		method: "POST",
		body: JSON.stringify({ category, cursor }),
		headers: {
			"Content-Type": "application/json",
		},
	});
	const data = await response.json();
	return data
}
const Comment = ({ postData }) => {
	const isMobileDevice = useIsMobile();
	const posts = postData?.edges || null
	const postpageInfo = postData?.pageInfo || null
	const [postList, setPostList] = useState(posts)
	const [loadingLoad, setLoadingLoad] = useState(false)
	const [pageInfo, setPageInfo] = useState(postpageInfo)

	const router = useRouter()
	const slug = router.query.slug || []
	const mainSlug = slug[slug.length - 1];
	const [storeCookie, setStoreCookie] = useCookies(["store"])
	const [websiteID, setWebsiteID] = useState(1)

	const [prefixUrl, setPrefixUrl] = useState('')

	const breadCrumbUrl = getBreadCrumbURL(websiteID)

	 
	const url = getRedirectionURL(`category/${mainSlug}`);

	const { showNotifyModal, handleModalClose } = useNotifyModal();

	useEffect(() => {
		setWebsiteID(getWebsiteID(storeCookie))
	}, [storeCookie]);


	useEffect(() => {
		setPrefixUrl((websiteID == 1) ? "" : "/international")
	}, [websiteID]);

	function loadMore() {
		setLoadingLoad(true)
		// e.preventDefault();
		// setButtonText("Please Wait")
		// const result =  getCategoryPosts(mainSlug, pageInfo.endCursor,apolloClient);

		const result = getNewData(mainSlug, pageInfo.endCursor);
		const response = async () => {
			try {
				const tmp = await result;

				setLoadingLoad(false)
				if (tmp && tmp.posts) {
					const lposts = ((tmp.posts && tmp.posts.edges) ? tmp.posts.edges : null)
					const lpostpageInfo = ((tmp.posts && tmp.posts.pageInfo) ? tmp.posts.pageInfo : null)
					let existPost = postList.concat(lposts);
					setPostList(existPost);
					setPageInfo(lpostpageInfo)
				}
			} catch (error) {
				console.log('error', error);
				setLoadingLoad(false)
			}
		};
		response();
	}
	let title = mainSlug + " | Kama Ayurveda"
	return <>
		<div>
			<Head>
				<title>{title}</title>
				<meta name="title" content={title} />
				<meta name="description" content="Kama Ayurveda" />
				<meta name="keywords" content="ayurveda online shop,ayurvedic beauty products,ayurvedic cosmetic products,ayurvedic hair products,ayurvedic online store,ayurvedic products,ayurveda for skin" />
				<meta property="og:title" content={title} />
				<meta property="og:description" content="Kama Ayurveda" />
				<meta property="og:image" content={process.env.NEXTAUTH_URL + "/images/Kama-Brand-Logo.png"} />
				<meta property="twitter:description" content="Kama Ayurveda" />
				<meta property="twitter:title" content={title} />
			</Head>
			<div className="container">	 {!isMobileDevice && (
				<div className="breadcrumbs_sec">
					<nav>
						<ol>
							{generateBreadcrumbs(router, breadCrumbUrl, false)?.map((list, id) => (
								<li key={id}><Link href={list.href}>{list.title}</Link></li>
							))}
						</ol>
					</nav>
				</div>
			)}

				{showNotifyModal ? <NotifyModal
					isOpen={showNotifyModal}
					handleModalClose={handleModalClose}
					className='notifyContent'
					redirectUrl={url?.redirectUrl || null}
					hreflangUrl={url?.hreflangUrl || null}
				/> : null}

			</div>
			<div className="container">
				<div className={classes['journal-colm8']}>

					<h1>{mainSlug}</h1>
					<div className="row">
						{
							((postList) ? (
								postList.map(({ node }) => (

									<div className={`col-12 col-md-4 ` + classes['col-md-4']}>
										<div className={classes["blog-product"]} key={node.id}>
											<div className={classes["img-blog"]}>
												<Link href={`${prefixUrl}/blog/${node.slug}`}>

													<img loading="lazy" src={(node.featuredImage && node.featuredImage.node && node.featuredImage.node.mediaDetails && node.featuredImage.node.mediaDetails.file) ? process.env.WP_IMG_URL + node.featuredImage.node.mediaDetails.file : ''} alt={node.title} />

												</Link>
											</div>
											<div className={classes["col"]}>
												<abbr className="float-start">{node.categories.nodes[0].name} | {formatDate(node.date)}</abbr>
												<abbr className="float-end">{readTime(node.content)} MINS READ</abbr>
											</div>
											<h3>{node.title}</h3>
											<div dangerouslySetInnerHTML={{ __html: (node.excerpt) }} />
											<Link href={`${prefixUrl}/blog/${node.slug}`}>Read article</Link>
										</div>
									</div>
								))
							) : 'No record found')
						}	</div>
					{
						((loadingLoad == true) ? (
							<div className={classes["blog-product"]} >
								<div className={classes["img-blog"]}>
									<Skeleton count={1} height={140} style={{ marginBottom: 10 }} />
								</div>
								<Skeleton count={1} height={30} />
								<Skeleton count={1} height={50} />
							</div>

						) : (
							(pageInfo && pageInfo.hasNextPage) ? (
								<div className={classes["see-all-btn"] + ' pt-2'}><a onClick={(e) => loadMore()}>See more</a></div>
							) : null
						))

					}

				</div>
			</div>
		</div>
	</>;
}


export async function getStaticPaths() {
	// const allCat = await getAllCategoriesNew();

	// const paths = (allCat && allCat.length>0) ?  allCat.map(({ node }) => {
	// 	let pathArray = [];
	// 	if (node.parent) {
	// 		pathArray = [node.parent.node.slug, node.slug];
	// 	} else {
	// 		pathArray = [node.slug];
	// 	}
	// 	return {
	// 		params: {
	// 			slug: pathArray
	// 		}
	// 	}
	// }) : []
	return {
		paths: [],
		fallback: 'blocking'
	};
}

export async function getStaticProps({ params }) {
	const slug = params.slug;
	const mainSlug = slug[slug.length - 1];
	const data = await getCategoryPosts(mainSlug);
	return {
		props: {
			postData: data,
		}
	};
}

export default Comment